<template>
    <kubernetes-common-panel
            v-model="value"
            :img="img"
            :readOnly="readOnly"
            @openDesDoc="desDocOpen"
            @close="closePanel"
    >
        <template slot="headline">
            <v-list-item-title class="headline">
                {{ value._type }}
            </v-list-item-title>
        </template>

        <template slot="descriptionText">
            <span>{{ descriptionText }}</span>
        </template>
        
    </kubernetes-common-panel>

</template>


<script>
    import KubernetesPanel from "../KubernetesPanel";
    
    export default {
        mixins: [KubernetesPanel],
        name: 'sensor-property-panel',
        computed: {
            descriptionText() {
                return 'Sensor'
            },
        },
        data: function () {
            return {}
        },
        watch: {
        },
        methods: {
        }
    }
</script>

